<template>
  <div class="nav-backdrop" :class="{ active: !isCollapsed }" @click="closeCollapse"></div>
  <header>
    <nav id="top-of-page" class="navbar navbar-expand-lg navbar-light btm-bar" :class="{ inverse: inverse }"
      :style="inverse ? {} : { backgroundColor: bgColor }">
      <div class="container-fluid px-1 px-lg-5">
        <a class="navbar-brand" href="/">
          <!-- <img :src="`${$API_ASSETS}509d08fb-5e4c-461a-b041-aab23744c960.png`" class="img-fluid d-md-inline logo" alt="globe" /> -->
          <img
            :src="inverse ? `${$API_ASSETS}2a971657-e0a7-4dc3-8536-d2b682561f1a.png` : `${$API_ASSETS}41e4b0d7-2b51-456a-8504-55972fd1c8ee.png`"
            class="img-fluid logo" alt="Logo" />
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"
          aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse"
          :style="inverse ? { backgroundColor: '#231F20' } : { backgroundColor: bgColor }">
          <ul class="navbar-nav ms-auto d-flex align-items-center">
            <li class="nav-item px-3">
              <router-link class="nav-link open-sans-500" to="/shows" @click="closeCollapse">Shows</router-link>
            </li>
            <li class="nav-item px-3">
              <router-link class="nav-link open-sans-500" to="/classes" @click="closeCollapse">Classes</router-link>
            </li>
            <li class="nav-item px-3">
              <router-link class="nav-link open-sans-500" to="/jam" @click="closeCollapse">Jam</router-link>
            </li>
            <li class="nav-item px-3">
              <router-link class="nav-link open-sans-500" to="/thecut" @click="closeCollapse">The Cut</router-link>
            </li>
            <li class="nav-item px-3">
              <router-link class="nav-link work-sans-500" to="/company" @click="closeCollapse">Company</router-link>
            </li>
<li class="nav-item px-3">
              <router-link class="nav-link work-sans-500" to="/contact" @click="closeCollapse">Contact</router-link>
            </li>
            <li class="nav-item px-3">
              <router-link class="nav-link work-sans-500" to="/hireus" @click="closeCollapse">Hire</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  props: {
    bgColor: {
      type: String,
      default: '#E35B4B', // Default background color if none is provided
    },
    inverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCollapsed: true,
    };
  },
  methods: {
    isActive(route) {
      return this.$route.path === route;
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    closeCollapse() {
      this.isCollapsed = true;
      const el = document.getElementById('navbarCollapse');
      if (el && el.classList.contains('show')) {
        const Collapse = window.bootstrap?.Collapse;
        if (Collapse) {
          Collapse.getOrCreateInstance(el).hide();
        } else {
          el.classList.remove('show');
        }
      }
    },
  },
  mounted() {
    setTimeout(() => {
      const el = document.getElementById('top-of-page');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);

    const collapseEl = document.getElementById('navbarCollapse');
    if (collapseEl) {
      collapseEl.addEventListener('show.bs.collapse', () => { this.isCollapsed = false; });
      collapseEl.addEventListener('hide.bs.collapse', () => { this.isCollapsed = true; });
    }
  },

  created() {
    // Set up a global navigation guard to update the admin level before navigation
    this.$router.beforeEach(() => {
      this.closeCollapse(); // Close the collapse element before navigating
    });
  },
};
</script>

<style scoped>
/* Add your styles here if needed */
.navbar {
  transition: background-color 0.35s ease;
  position: relative;
  z-index: 1050;
}

.nav-link,
.navbar-brand {
  transition: color 0.35s ease, opacity 0.35s ease;
}

.logo {
  transition: opacity 0.35s ease;
}

/* Inverse Nav style */
.inverse {
  background-color: #231F20 !important;
}

.inverse .nav-link,
.inverse .navbar-brand,
.inverse .navbar-toggler,
.inverse .navbar-toggler-icon {
  color: white !important;
  fill: white !important;
}

.inverse .nav-link.router-link-exact-active {
  color: #fff !important;
}

/* Ensure logo images are not inverted */
.inverse .logo {
  filter: none;
}

.inverse .navbar-toggler {
  border-color: white;
}

.inverse .navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba%28255, 255, 255, 1%29' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
}

.nav-backdrop {
  display: none;
  position: fixed;
  inset: 0;
  z-index: 1039;
  background: rgba(0, 0, 0, 0.45);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.35s ease;
}

.nav-backdrop.active {
  opacity: 1;
  pointer-events: auto;
}


@media (max-width: 991.98px) {
  .nav-backdrop {
    display: block;
  }

#navbarCollapse {
    padding: 1rem 0 1.5rem;
  }

  .navbar-nav {
    align-items: center !important;
    width: 100%;
  }

  .nav-item {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .nav-item:last-child {
    border-bottom: none;
  }

  .inverse .nav-item {
    border-bottom-color: rgba(255, 255, 255, 0.12);
  }

  .nav-link {
    font-size: 1.2rem;
    padding: 0.85rem 1rem;
    display: block;
  }
}
</style>
